import { adminDataQualitySupportedFootballScopeSchema } from '@ballpeek/api/client'
import { createFileRoute } from '@tanstack/react-router'
import { AdminDataQualityRoutePage } from '~/features/admin-data-quality/components'
import {
  adminDataQualityArchivesQueryOptions,
  adminDataQualityCoverageQueryOptions,
} from '~/features/admin-data-quality/query-options'

const dataQualitySearchSchema = adminDataQualitySupportedFootballScopeSchema

export const Route = createFileRoute('/admin/data-quality')({
  validateSearch: dataQualitySearchSchema,
  loaderDeps: ({ search: { competitionCode, season } }) => ({ competitionCode, season }),
  loader: async ({ context, deps: { competitionCode, season } }) => {
    await Promise.all([
      context.queryClient.prefetchQuery(adminDataQualityCoverageQueryOptions({ competitionCode, season })),
      context.queryClient.prefetchQuery(adminDataQualityArchivesQueryOptions()),
    ])
  },
  component: AdminDataQualityRoutePage,
})
